/* Soneil Spark — conversion tracking.
   One delegated listener fires GA4 conversions to dataLayer (+ optional direct gtag):
   form submissions, Contact Us clicks, outbound clicks, downloads, and a universal
   cta_click on every link / submit button (section-aware, for full CTA coverage).
   Events queue until consent is granted (released by consent-bridge → SparkTrackGrant). */
(function () {
  var C = window.SparkTrack || {};
  var dl = (window.dataLayer = window.dataLayer || []);

  var directGA = function () {
    return C.ga4DirectFallback && C.ga4Id && typeof window.gtag === "function";
  };

  var consentGranted = !C.consentModeEnabled;
  var queue = [];
  function emit(gaName, dlEvent, params) {
    var fire = function () {
      dl.push(Object.assign({ event: dlEvent }, params));
      if (directGA()) window.gtag("event", gaName, Object.assign({ transport_type: "beacon" }, params));
    };
    if (consentGranted) fire();
    else queue.push(fire);
  }
  // Shared consent-aware emitter for other theme scripts (product.js → view_item / add_to_cart).
  window.SparkTrackEmit = emit;
  window.SparkTrackGrant = function () {
    consentGranted = true;
    var q = queue.splice(0);
    for (var i = 0; i < q.length; i++) q[i]();
  };

  var shopHost = (C.shopHost || location.hostname).replace(/^www\./, "");
  function text(el) {
    var t = (el.textContent || "").trim().replace(/\s+/g, " ");
    return (t || el.getAttribute("aria-label") || "").slice(0, 100);
  }
  // Human-readable section slug from the Shopify section wrapper the element sits in.
  function sectionOf(el) {
    var s = el.closest(".shopify-section");
    if (!s || !s.id) {
      var lm = el.closest("header, footer, nav, main");
      return lm ? lm.tagName.toLowerCase() : "page";
    }
    return s.id
      .replace(/^shopify-section-/, "")
      .replace(/^(template|sections)--\d+__/, "");
  }
  var FILE_EXT = ["pdf","doc","docx","xls","xlsx","csv","ppt","pptx","zip","dwg","txt","rtf","key"];

  document.addEventListener(
    "click",
    function (e) {
      var a = e.target.closest("a, button");
      if (!a) return;

      if (C.trackContact && a.matches("[data-ga-contact]")) {
        emit("contact_click", "contact_click", {
          contact_location: a.getAttribute("data-ga-contact") || "unknown",
          link_text: text(a)
        });
      }

      // Universal CTA coverage: every real link, every submit button, plus anything
      // opted in with data-ga-cta. Disclosure/utility buttons (accordions, menu
      // toggles, qty steppers, variant pills) stay out unless tagged.
      if (C.trackCta && !a.hasAttribute("data-ga-ignore")) {
        var isLink = a.tagName === "A" && a.getAttribute("href") && a.getAttribute("href").charAt(0) !== "#";
        var isSubmit = a.tagName === "BUTTON" && (a.type === "submit" || a.hasAttribute("data-ga-cta"));
        if ((isLink || isSubmit) && !a.hasAttribute("aria-expanded") && !a.hasAttribute("aria-haspopup")) {
          emit("cta_click", "cta_click", {
            link_text: text(a),
            link_url: a.getAttribute("href") || (a.form && a.form.getAttribute("action")) || "",
            link_location: sectionOf(a)
          });
        }
      }

      var href = a.getAttribute("href") || "";
      if (!href || href.charAt(0) === "#") return;

      var ext = (href.split("?")[0].match(/\.([a-z0-9]{2,5})$/i) || [])[1];
      ext = ext ? ext.toLowerCase() : "";
      var isFile = a.hasAttribute("data-ga-download") || FILE_EXT.indexOf(ext) !== -1;
      if (C.trackDownload && isFile) {
        emit("file_download", "file_download", {
          file_name: a.getAttribute("data-ga-file-name") || href.split("/").pop().split("?")[0],
          file_extension: ext,
          link_url: href,
          link_text: text(a)
        });
      }

      if (C.trackOutbound && /^https?:\/\//i.test(href)) {
        try {
          var u = new URL(href, location.href);
          if (u.hostname && u.hostname.replace(/^www\./, "") !== shopHost) {
            emit("outbound_click", "outbound_click", {
              outbound: true,
              link_url: href,
              link_domain: u.hostname,
              link_text: text(a)
            });
          }
        } catch (err) {}
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (e) {
      if (!C.trackForm) return;
      var f = e.target.closest("form[data-ga-form]");
      if (!f) return;
      var cat = f.querySelector('[name*="category"], [name*="reason"]');
      emit("generate_lead", "form_submit", {
        form_name: f.getAttribute("data-ga-form-name") || f.id || "contact",
        form_destination: f.getAttribute("action") || "",
        lead_category: cat ? cat.value : "",
        value: 0,
        currency: "CAD"
      });
    },
    true
  );
})();
